// @flow strict

import * as React from 'react';
import cx from 'classnames';

type sizeType = {|
  width: number,
  height?: number,
|};

type srcSetType = {|
  mediaMaxWidth: number | 'default',
  ...sizeType,
|};

type PropTypes = {|
  src: string,
  alt: string,
  className?: string,
  srcSet: Array<srcSetType>,
  defaultSize: sizeType,
|};

export const buildKenticoResponsiveImage = (src: string = '', { width, height }: sizeType) => {
  const notGif = !src.endsWith('.gif');
  // if height is set and image is not a gif use the height to responsively generate the ideal image
  // otherwise use width
  const queryString = height ? `height=${height}` : `width=${width}`;
  // eslint-disable-next-line prefer-template
  return `${src}${queryString && notGif ? '?' + queryString : ''}`;
};

const buildSrcSet = (src: string, srcSet: Array<srcSetType>, defaultSize: sizeType) => {
  const retinaSpecs = {
    width: defaultSize.width * 2,
    height: defaultSize.height && defaultSize.height * 2,
  };
  return [
    ...srcSet.map(srcSetItem => {
      const size = { width: srcSetItem.width, height: srcSetItem.height };
      return `${buildKenticoResponsiveImage(src, size)} ${srcSetItem.width}w`;
    }),
    `${buildKenticoResponsiveImage(src, defaultSize)} ${defaultSize.width}w`,
    `${buildKenticoResponsiveImage(src, retinaSpecs)} ${defaultSize.width * 2}w`,
  ].join(', ');
};

const buildSizes = (src: string, srcSet: Array<srcSetType>, defaultSize: sizeType) =>
  [
    ...srcSet.map(srcSetItem => `(max-width: ${srcSetItem.mediaMaxWidth}px) ${srcSetItem.width}px`),
    `${defaultSize.width}px`,
  ].join(', ');

const ResponsiveImage = (props: PropTypes) => (
  <>
    <img
      data-src={buildKenticoResponsiveImage(props.src, props.defaultSize)}
      alt={props.alt}
      className={cx(['lazyload', props.className])}
      data-srcset={buildSrcSet(props.src, props.srcSet, props.defaultSize)}
      data-sizes={
        props.srcSet.length > 0 ? buildSizes(props.src, props.srcSet, props.defaultSize) : undefined
      }
    />
    <noscript>
      <img
        src={buildKenticoResponsiveImage(props.src, props.defaultSize)}
        alt={props.alt}
        className={cx([props.className])}
        srcSet={buildSrcSet(props.src, props.srcSet, props.defaultSize)}
        sizes={
          props.srcSet.length > 0
            ? buildSizes(props.src, props.srcSet, props.defaultSize)
            : undefined
        }
      />
    </noscript>
  </>
);

ResponsiveImage.defaultProps = {
  srcSet: [],
  alt: '',
};

export default ResponsiveImage;
